var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-container w-e-text-container"},[_c('div',{staticClass:"preview-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.html)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }